// extracted by mini-css-extract-plugin
export var avatarContainer = "_h3-0";
export var avatarTypingWave = "_h3-i";
export var gray = "_h3-f";
export var green = "_h3-c";
export var icon = "_h3-9";
export var image = "_h3-1";
export var lg = "_h3-6";
export var md = "_h3-5";
export var presenceDot = "_h3-b";
export var red = "_h3-d";
export var sm = "_h3-4";
export var status = "_h3-a";
export var typingDot = "_h3-h";
export var typingPill = "_h3-g";
export var xl = "_h3-7";
export var xs = "_h3-3";
export var xxl = "_h3-8";
export var xxs = "_h3-2";
export var yellow = "_h3-e";